module.exports = __webpack_public_path__ + "img/oldcustomservice.22505c66.png";